enum RoutesPath {
  // Common routes
  Properties = "/properties",
  PropertyDetails = "/properties/:id",
  PropertyMediaFolder = "/properties/:id/folder/:folderId",
  PropertyPreview = "/properties/:id/preview",
  PropertyPublicPreview = "/properties/:id/public-preview",
  PropertyAgentPreview = "/properties/:id/agent-preview",
  PropertyDirectPreview = "/properties/:id/direct-preview",
  Organizations = "/organizations",
  OrganizationDetails = "/organizations/:id",
  Amenities = "/amenities",
  Brokers = "/brokers",
  BrokersDetails = "/brokers/:id",
  Seekers = "/seekers",
  SeekersDetails = "/seekers/:id",
  ExternalSales = "/external-sales",
  ExternalSalesUsers = "/external-sales/:id",
  Management = "/management",
  APIManagement = "/api",
  APIManagementCompanyDetails = "/api/companies/:id",
  APIManagementPluginUserDetails = "/api/plugin-users/:id",
  APIConsole = "/api-console",
  APIConsoleAccountDetails = "/api-console/accounts/:id",
  APIConsolePluginUserDetails = "/api-console/plugin-users/:id",
  ContentActivity = "/content-activity",
  FeaturedContent = "/featured-content",
  FeaturedContentPortfolios = "/featured-content/portfolios",
  FeaturedContentPortfoliosDetails = "/featured-content/portfolios/:id",
  FeaturedContentProperties = "/featured-content/featured-properties",
  FeaturedContentPropertiesDetails = "/featured-content/featured-properties/:id",
  FeaturedPortfolios = "/featured-portfolios",
  FeaturedPortfolioDetails = "/featured-portfolios/:id",
  FeaturedProperties = "/featured-properties",
  FeaturedPropertyDetails = "/featured-properties/:id",
  SignIn = "/auth/sign-in",
  SignInMFA = "/auth/sign-in/mfa",
  SignUp = "/auth/sign-up",
  ForgotPassword = "/auth/forgot-password",
  ResetPassword = "/auth/resetPassword",
  Account = "/account",
  MarketAreas = "/market-areas",
  // public urls
  TermConditions = "/term-conditions",
  PrivacyPolicy = "/privacy-policy",
}

/**
 * A sidebar entry is active on its own screen and on anything nested under it.
 * Substring matching would also light `/api` up while `/api-console` is open.
 */
const isRouteActive = (pathname: string, path: string): boolean =>
  pathname === path || pathname.startsWith(`${path}/`);

export { RoutesPath, isRouteActive };
